import React from "react";
import { Modal, Table, Button } from "antd";

const ModalLogMonthDescription = ({ 
    isOpen, 
    onClose, 
    month, 
    logsMonthData 
}) => {

  // Cấu trúc bảng Logs trong modal con
  const logsColumns = [
    {
        title: "Time",
        dataIndex: "time",
        key: "time",
    },
    {
        title: "User",
        dataIndex: "user",
        key: "user",
    },
    {
        title: "Detail",
        dataIndex: "detail",
        key: "detail",
        render: (text) => text || "No detail provided",
    },
  ];

  return (
    <Modal
      title={`Logs Data for Month ${month}`}
      open={isOpen}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
      width={800}
    >
      <Table columns={logsColumns} dataSource={logsMonthData} pagination={false} />
    </Modal>
  );
};

export default ModalLogMonthDescription;
